export const AppRoutes = {
  sharer: "/share/:applicationId",
};